/* techimages import */
import aws from "../images/aws.png";
import shopify from "../images/shopify-plus.png";
import digitalocean from "../images/digitalocean.png";
import node from "../images/node.png";
import codeigniter from "../images/codeigniter.png";
import bigcommerce from "../images/bigCommerce.png";
import php from "../images/php.png";
const statisticsData = [
  {
    id: 1,
    title: "Web App <br /> Development",
    valueEnd: 95,
    duration: 1.4,
    valueStart: 0,
  },
  {
    id: 2,
    title: "Mobility <br /> Development",
    valueEnd: 87,
    duration: 1.4,
    valueStart: 0,
  },
  {
    id: 3,
    title: "UI/UX <br /> Development",
    valueEnd: 90,
    duration: 1.4,
    valueStart: 0,
  },
  {
    id: 4,
    title: "SEO <br /> and SEM",
    valueEnd: 80,
    duration: 1.4,
    valueStart: 0,
  },
  {
    id: 5,
    title: "Application <br /> Optimization",
    valueEnd: 83,
    duration: 1.4,
    valueStart: 0,
  },
];
const techListData = [
  {
    img: aws,
    title: "AWS",
  },
  {
    img: shopify,
    title: "Shopify-plus",
  },
  {
    img: digitalocean,
    title: "Digital Ocean",
  },
  {
    img: node,
    title: "Node Js",
  },
  {
    img: codeigniter,
    title: "Codeigniter",
  },
  {
    img: bigcommerce,
    title: "Bigcommerce",
  },
  {
    img: php,
    title: "PHP",
  },
];

const statisticsHomeData = [
  {
    countNum: "10",
    suffix: "+",
    title: "Years in Service",
  },
  {
    countNum: "60",
    suffix: "+",
    title: "Google Reviews",
  },
  {
    countNum: "1000",
    suffix: "+",
    title: "Happy Clients",
  },
  {
    countNum: "80",
    suffix: "+",
    title: "In-House Tech Geeks",
  },
];

export { statisticsData, statisticsHomeData, techListData };
